import { useState } from "react";
import Header from "./Header/Header";
import Sidebar from "./Sidebar/Sidebar";
import { MdSwapVert } from "react-icons/md";
import { FaArrowRight, FaCaretDown, FaCaretUp } from "react-icons/fa";

const coinOptions = [
  {
    label: "USDT ",
    img: "https://res.cloudinary.com/daafoiwvn/image/upload/v1726234202/vfq8obb4j4hfzj36vfih.png",
  },
  {
    label: "BNB",
    img: "https://res.cloudinary.com/taikonz-com/image/upload/v1664014615/fd2vqjmjipjxvzt6g2re.png",
  },
  {
    label: "ETH",
    img: "https://res.cloudinary.com/daafoiwvn/image/upload/v1726233359/mw0m6edznzjzfqfapazc.png",
  },
  {
    label: "BTC",
    img: "https://res.cloudinary.com/daafoiwvn/image/upload/v1726232941/dwecw2qrcrkahqdwyryv.png",
  },
  {
    label: "XRP",
    img: "https://res.cloudinary.com/daafoiwvn/image/upload/v1726234044/tpefmwn0fsylrekphisg.png",
  },
];

const receiveOptions = [
  {
    label: "Urban Blocks ",
    img: new URL("./../assets/mrkt_card_icontop.webp", import.meta.url),
  },
  {
    label: "Value Infi",
    img: new URL("./../assets/mrkt_card_icontop2.webp", import.meta.url),
  },
  {
    label: "Maxi Group",
    img: new URL("./../assets/mrkt_card_icontop3.webp", import.meta.url),
  },
  {
    label: "Skyline Towers",
    img: new URL("./../assets/mrkt_card_icontop4.webp", import.meta.url),
  },
  {
    label: "MetroBlocks",
    img: new URL("./../assets/mrkt_card_icontop6.webp", import.meta.url),
  },
];

const Swap = () => {
  const [selected, setSelected] = useState(coinOptions[0]);
  const [selectedReceive, setSelectedReceive] = useState(receiveOptions[0]);

  return (
    <>
      <Header />

      <main className="main_flx">
        <Sidebar />

        <div className="right_wrap">
          <div>
            <h4 className="subheading">Swap</h4>

            <div className="swap_box">
              <div className="swap_head">
                <h5 className="swap_subtitle">You will pay</h5>
                <div className="swap_hd_flx">
                  <div className="dropdown swap_dropdown">
                    <button
                      className="dropdown-toggle swap_dropdown_toggle"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <span className="swp_lft_flx">
                        <img
                          src={selected.img}
                          alt={selected.label}
                          width="20"
                          height="20"
                          style={{ borderRadius: "50%" }}
                        />
                        {selected.label}
                      </span>
                    </button>
                    <ul className="dropdown-menu swp_dropdown_menu">
                      {coinOptions.map((opt) => (
                        <li key={opt.label}>
                          <button
                            className="dropdown-item swp_dropdown_item"
                            onClick={() => setSelected(opt)}
                          >
                            <img
                              src={opt.img}
                              alt={opt.label}
                              width="20"
                              height="20"
                              style={{ borderRadius: "50%" }}
                            />
                            {opt.label}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <input
                    type="number"
                    placeholder="Enter the amount"
                    className="swap_input"
                  />
                </div>
                <h3 className="swap_bln">
                  <span>Balance : </span>2350 USDC
                </h3>
              </div>

              <div className="swap_icon_wrap">
                <div className="swap_icon_inner">
                  <MdSwapVert />
                </div>
              </div>

              <div className="swap_body">
                <h5 className="swap_subtitle">You will receive</h5>
                <div className="swap_hd_flx">
                  <div className="dropdown swap_dropdown">
                    <button
                      className="dropdown-toggle swap_dropdown_toggle"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <span className="swp_lft_flx">
                        <img
                          src={selectedReceive.img}
                          alt={selectedReceive.label}
                          width="20"
                          height="20"
                          style={{ borderRadius: "50%" }}
                        />
                        {selectedReceive.label}
                      </span>
                    </button>
                    <ul className="dropdown-menu swp_dropdown_menu">
                      {receiveOptions.map((opt) => (
                        <li key={opt.label}>
                          <button
                            className="dropdown-item swp_dropdown_item"
                            onClick={() => setSelectedReceive(opt)}
                          >
                            <img
                              src={opt.img}
                              alt={opt.label}
                              width="20"
                              height="20"
                              style={{ borderRadius: "50%" }}
                            />
                            {opt.label}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <input
                    type="number"
                    placeholder="Enter the amount"
                    className="swap_input"
                  />
                </div>
                <h3 className="swap_bln">
                  <span>Rate : </span>1 UB = 100 USDC
                </h3>

                <div className="swp_spg">
                  <span>Slippage Tolerance:</span>
                  <div className="swp_input_wrap">
                    <input
                      type="number"
                      value={0.5}
                      className="swp_spg_input"
                    />

                    <div className="swp_spg_indicators">
                      <FaCaretUp />
                      <FaCaretDown />
                    </div>
                  </div>
                </div>

                <div className="swp_cnt_wrap">
                  <div className="swp_cnt_flx">
                    <span>Swap Fee</span>
                    <h6>0.20%</h6>
                  </div>
                  <div className="swp_cnt_flx">
                    <span>Estimated Time</span>
                    <h6>15 sec</h6>
                  </div>
                  <div className="swp_cnt_flx">
                    <span>Route</span>
                    <h6>
                      USDC <FaArrowRight /> Urban Blocks
                    </h6>
                  </div>
                  <div className="swp_cnt_flx">
                    <span>st. Gas Fees</span>
                    <h6>$1.25</h6>
                  </div>
                  <div className="swp_cnt_flx">
                    <span>Minimum Received</span>
                    <h6>9.85 UB Tokens</h6>
                  </div>
                </div>

                <div className="swp_btn_wrap">
                  <button className="swp_btn_lft">
                    <span>Swap Now</span>
                  </button>
                  <button className="swp_btn_rgt">Advance Setting</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Swap;
